import { Button, Input, InputNumber, message, Select, Space, Table, Typography, Card, Form } from "antd";
import "./visit-cnt.css";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import VisitCntItem from "./visit-cnt-item";
import { DownOutlined, RightOutlined, WarningOutlined } from "@ant-design/icons";
import VisitCntPacket from "./visit-cnt-packet";
import VisitCntPacketItem from "./visit-cnt-packet-item";
import ClientAbons from "../clients/client-abons";
import SaleAdd from "../sales/sale-add";
import { Scan } from "../../controls";
import { isMobile, ScanButton } from "../../extensions/design";
import ButtonReport from "../../controls/button-report/button-report";
import { fmtDate, fmtTimeHM } from "@/extensions/utils";
import { dictsGetPaymentVids } from "../../extensions/dicts";
import { handleOnlyNumbersKeyDown, ONLY_NUMBERS_PARSER } from '../../extensions/utils';

const { Text } = Typography;

const VisitCnt = ({ item, onRefresh, page = 0, setPage, onHasNonZeroDepositChange }) => {
  const [loading, setLoading] = useState(false);
  const [sales, setSales] = useState([]);
  const [uses, setUses] = useState([]);
  const [selected, setSelected] = useState([]);
/*   const [abons, setAbons] = useState([]);
  const [packages, setPackages] = useState([]); */
  const [form] = Form.useForm();
  const [itemZag, setItemZag] = useState({...item, modified: false});
  const [saleAdd, setSaleAdd] = useState(false);
  const [editId, setEditId] = useState();
  const [visitInfoExpanded, setVisitInfoExpanded] = useState(false);
  const [formModified, setFormModified] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [vidPayments, setVidPayments] = useState([]);
  const [depositAction, setDepositAction] = useState(null);
  const [certificateAction, setCertificateAction] = useState(null);
  const penaltyVid = Number(item?.penaltyVid ?? item?.PenaltyVid ?? 0);

  const penaltyLabel = penaltyVid === 2 && (<span className="visit-time-overrun-label"><WarningOutlined /> Превышение времени </span> );

  const getData = () => {
    setLoading(true);
    Promise.all([
      serverFetch(`sale/ListByVisit/${item.id}?deleted=false`),
      serverFetch(`sale/UseListByVisit/${item.id}`),
    ])
      .then(([salesData, usesData]) => {
        const sortedSales = (salesData ?? []).sort((a, b) => a.id - b.id);
        const sortedUses = (usesData ?? []).sort((a, b) => a.id - b.id);
        setLoading(false);
        setSales(sortedSales);
        setUses(sortedUses);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, [item]);

  useEffect(() => { dictsGetPaymentVids(data => setVidPayments(data)); }, []);

  useEffect(() => {
    if (item?.clientId) {
      serverFetch(`payment/accounts/client/${item.clientId}`)
        .then(data => setAccounts(data))
        .catch(e => message.error(e.userMessage));
    } else {
      if (item?.id) {
        serverFetch(`payment/accounts/visit/${item.id}`)
          .then(data => setAccounts(data))
          .catch(e => message.error(e.userMessage));
      }
    }
  }, [item?.clientId, item?.id]);

  useEffect(() => {
    if (!itemZag.modified && !formModified) {
      const newItemZag = {...item, modified: false};
      setItemZag(newItemZag);
      form.setFieldsValue({ comment: item.comment || '', keyName: item.keyName || '' });
      setFormModified(false);
    }
  }, [item]);
  
/*   const getAbons = () => {
    setLoading(true);
    serverFetch(`sale/ListByClient/${item.clientId}?vids=2&vids=3`)
      .then(data => {
        setLoading(false);
        if (!data) return;

        const abons = data.filter(x => x.productVid === 2);
        const packages = data.filter(x => x.productVid === 3);

        setAbons(abons);
        setPackages(packages);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getAbons, [item]); */

  const visitAccounts = accounts.filter(acc => acc.fiscal >= 21 && acc.fiscal <= 23);
  const depositAccount = visitAccounts.find(acc => acc.fiscal === 21);
  const hasNonZeroDeposit = depositAccount && depositAccount.syma !== 0;
  const depositPaymentOptions = vidPayments.filter(v => v.fiscal !== 21 && v.fiscal !== 22 && v.fiscal !== 23);

  useEffect(() => { onHasNonZeroDepositChange?.(hasNonZeroDeposit); }, [hasNonZeroDeposit]);

  const refreshAccounts = () => {
    if (item?.clientId) {
      serverFetch(`payment/accounts/client/${item.clientId}`)
        .then(data => setAccounts(data))
        .catch(e => message.error(e.userMessage));
    } else {
      if (item?.id) {
        serverFetch(`payment/accounts/visit/${item.id}`)
          .then(data => setAccounts(data))
          .catch(e => message.error(e.userMessage));
      }
    }
  };

  const openDepositAction = (account, type) => {
    if (depositAction?.accountId === account.id && depositAction?.type === type) {
      setDepositAction(null);
    } else {
      setDepositAction({ accountId: account.id, paymentVid2Id: account.id, type, syma: type === 'Return' ? account.syma : '', paymentVidId: null, comment: '' });
    }
  };

  const onDepositSubmit = () => {
    if (!depositAction?.syma || !depositAction?.paymentVidId) {
      message.warning("Заполните сумму и кассу");
      return;
    }
    const body = {
      ...(item.clientId ? { clientId: item.clientId } : { visitId: item.id }),
      paymentVidId: depositAction.paymentVidId,
      paymentVid2Id: depositAction.paymentVid2Id,
      transactionVid: depositAction.type === 'Payment' ? 1 : -1,
      syma: depositAction.syma,
      comment: depositAction.comment,
    };
    setLoading(true);
    serverFetch("payment/deposit", { method: "POST", bodyData: body })
      .then(() => {
        setDepositAction(null);
        setLoading(false);
        refreshAccounts();
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

    const onCertificateSubmit = () => {
    if (!certificateAction?.saleId || !certificateAction?.saleClientId) {
      message.warning("Заполните номер сертификата и проверочный код");
      return;
    }
    const body = {
      saleId: certificateAction.saleId,
      saleClientId: certificateAction.saleClientId,
      ...(item.clientId ? { clientId: item.clientId } : { visitId: item.id }),
      paymentVidId: certificateAction.paymentVidId
    };
    console.log(body)
    setLoading(true);

    let saleData = null;

    serverFetch(`sale/${certificateAction?.saleId}`)
      .then(response => {
        saleData = response;
        
        if (response?.deleted === true) {
          message.error("Погашение невозможно: сертификат удален");
        } else {
          serverFetch("sale/certificate/use", {
            method: "POST",
            bodyData: body,
          })
            .then(() => {
              setCertificateAction(null);
              setLoading(false);
              refreshAccounts();
            })
            .catch(e => {
              setLoading(false);
              message.error(e.userMessage);
            });
        }
      })
      .catch(error => {
        console.error('Ошибка:', error);
      });
  };



  const renderDepositForm = () => (
    !isMobile ? (
    <Form labelCol={{ span: 5 }} wrapperCol={{ span: 24 }} colon={false}
      style={{ marginTop: 8, paddingTop: 8, paddingRight: 8, backgroundColor: "#eff2ee", border: "1px solid #dddddd", borderRadius: "10px" }}>
      <Form.Item label="Сумма" style={{ marginBottom: 8 }}>
        <InputNumber value={depositAction?.syma} onChange={v => setDepositAction({ ...depositAction, syma: v })} style={isMobile ? { width: "100%" } : { width: 147 }} precision={2} stringMode={false} placeholder="0.00" />
      </Form.Item>
      <Form.Item wrapperCol={{ span: 12 }} label="Касса" style={{ marginBottom: 8 }}>
        <Select
        options={depositPaymentOptions.filter(option => option.fiscal !== 21 && option.fiscal !== 22 && option.fiscal !== 23)} 
         value={depositAction?.paymentVidId} onChange={v => setDepositAction({ ...depositAction, paymentVidId: v })} style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item label={isMobile ? "Коммент." : "Комментарий"} style={{ marginBottom: 8 }}>
        <Input value={depositAction?.comment} onChange={e => setDepositAction({ ...depositAction, comment: e.target.value })} />
      </Form.Item>
      <Form.Item label=" ">
        <Space>
          <Button style={{ width: "150px" }} onClick={onDepositSubmit} loading={loading}>ОК</Button>
          <Button style={{ width: "150px" }} onClick={() => setDepositAction(null)}>Отмена</Button>
        </Space>
      </Form.Item>
    </Form>
    ) : (
    <div style={{ paddingTop: 8 }}>
      <Form.Item label="Сумма" style={{ marginBottom: 8 }} labelCol={{span: 4}}>
        <InputNumber value={depositAction?.syma} onChange={v => setDepositAction({ ...depositAction, syma: v })} style={{ width: "100%" }} precision={2} stringMode={false} placeholder="0.00" />
      </Form.Item>
      <Form.Item label="Касса" style={{ marginBottom: 8 }} labelCol={{span: 4}}>
        <Select options={depositPaymentOptions} value={depositAction?.paymentVidId} onChange={v => setDepositAction({ ...depositAction, paymentVidId: v })} style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item label={"Комм."} style={{ marginBottom: 8 }} labelCol={{span: 4}}>
        <Input value={depositAction?.comment} onChange={e => setDepositAction({ ...depositAction, comment: e.target.value })} />
      </Form.Item>
      <div style={{ display: "flex", flexDirection: "row", gap: 8, width: "100%", marginBottom: 4 }}>
        <Button style={{ flex: 1, marginLeft: 8 }} onClick={onDepositSubmit} loading={loading}>ОК</Button>
        <Button style={{ flex: 1 }} onClick={() => setDepositAction(null)}> Отмена </Button>
      </div>
    </div>)
  );

  const renderCertificateForm = () => (
    !isMobile ? (
      <Form labelCol={{ span: 5 }} wrapperCol={{ span: 24 }} colon={false} style={{ marginTop: 8, paddingTop: 8, paddingRight: 8, backgroundColor: "#eff2ee", border: "1px solid #dddddd", borderRadius: "10px" }}>
        <Form.Item label={"Номер серт."} style={{ marginBottom: 8 }}>
          <InputNumber value={certificateAction?.saleId} onChange={v => setCertificateAction({ ...certificateAction, saleId: v })} parser={ONLY_NUMBERS_PARSER} onKeyDown={handleOnlyNumbersKeyDown} style={{ width: 147 }}/>
        </Form.Item>
        <Form.Item label="Проверочный код" style={{ marginBottom: 8 }}>
          <InputNumber value={certificateAction?.saleClientId} onChange={v => setCertificateAction({ ...certificateAction, saleClientId: v })} parser={ONLY_NUMBERS_PARSER} onKeyDown={handleOnlyNumbersKeyDown}/>
        </Form.Item>
        <Form.Item label=" ">
          <Space>
            <Button style={{width: "150px"}} onClick={onCertificateSubmit} loading={loading}>ОК</Button>
            <Button style={{width: "150px"}} onClick={() => setCertificateAction(null)}>Отмена</Button>
          </Space>
        </Form.Item>
      </Form>
    ) : (
    <div style={{ paddingTop: 8 }}>
      <Form.Item label="№ серт." style={{ marginBottom: 8 }} labelCol={{span: 5}}>
        <InputNumber value={certificateAction?.saleId} onChange={v => setCertificateAction({ ...certificateAction, saleId: v })} parser={ONLY_NUMBERS_PARSER} onKeyDown={handleOnlyNumbersKeyDown} style={{ width: "100%"}} />
      </Form.Item>
      <Form.Item label="Защ. код" style={{ marginBottom: 8 }} labelCol={{span: 5}}>
        <InputNumber value={certificateAction?.saleClientId} onChange={v => setCertificateAction({ ...certificateAction, saleClientId: v })} parser={ONLY_NUMBERS_PARSER} onKeyDown={handleOnlyNumbersKeyDown} style={{ width: "100%"}} />
      </Form.Item>
      <div style={{ display: "flex", flexDirection: "row", gap: 8, width: "100%", marginBottom: 4 }}>
        <Button onClick={onCertificateSubmit} loading={loading} style={{ flex: 1, marginLeft: 8 }}> ОК </Button>
        <Button onClick={() => setCertificateAction(null)} style={{ flex: 1 }}>Отмена</Button>
      </div>
    </div>
    )
  );

  const renderAccount = (account) => {
    const isDeposit = account.fiscal === 21;
    const isCertificate = account.fiscal === 22;

    return (
      <div key={account.id} className={isMobile ? "visit-account-row visit-account-row-mobile" : "visit-account-row"}>
        <div className="visit-account-main">
          <div className="visit-account-name">{account.name}</div>
          <Input disabled value={account.syma?.toFixed(2)} className="visit-account-input" />
        </div>
        
        {isDeposit && (
          <div className="visit-account-actions">
            <Button type={depositAction?.accountId === account.id && depositAction?.type === 'Payment' ? 'primary' : 'default'} onClick={() => openDepositAction(account, 'Payment')}>
            {isMobile ? "+" : "Пополнить"}
            </Button>
            <Button type={depositAction?.accountId === account.id && depositAction?.type === 'Return' ? 'primary' : 'default'} onClick={() => openDepositAction(account, 'Return')}>
              {isMobile ? "-" : "Вернуть"}
            </Button>
          </div>
        )}
        {isCertificate && (
          <div className="visit-account-actions visit-account-actions-certificate">
            <Button onClick={() => setCertificateAction({ accountId: account.id, saleId: null, saleClientId: null, clientId: item?.clientId, visitId: item.id, paymentVidId: accounts?.find(v => v.fiscal === 22)?.id})} style={{ width: '100%' }}>
              {isMobile ? "Серт." : "Погасить сертификат"}
            </Button>
          </div>
        )}
        {depositAction?.accountId === account.id && renderDepositForm()}
        {certificateAction?.accountId === account.id && renderCertificateForm()}
      </div>
    );
  };

  const divAccounts = visitAccounts.length > 0 && (
    <div className={isMobile ? "visit-accounts-block visit-accounts-block-mobile" : "visit-accounts-block"}>
      <div className="visit-accounts-title">Счета</div>
      {visitAccounts.map(renderAccount)}
    </div>
  );

  const renderDiscount = record => {
    if (record.discountPrc) return <div>{`${record.discountPrc}%`}</div>;
    if (record.discountSyma) return <div>{record.discountSyma}</div>;
    return <div />
  }

  const renderDebet = record => {
    const debet = record.syma - record.paid;
    if (debet) return <div>{debet}</div>
    return null;
  }

  const renderProductName = record => {
    let data = record.productName;
    if(record.recordStart && record.recordFinish) data += ` (${record.recordStart.substring(0, 5)} - ${record.recordFinish.substring(0, 5)})`;
    return <div>{data}</div>
  }

  const columns = [
    Table.SELECTION_COLUMN,
    { title: "Товар / услуга", width: "45%", render: renderProductName },
    { dataIndex: "price", title: "Цена", width: "10%", align: "right" },
    { dataIndex: "qty", title: "Кол.", width: "10%", align: "right" },
    { title: "Скидка", render: renderDiscount , width: "10%", align: "right" },
    { dataIndex: "syma", title: "Сумма", align: "right", width: "10%" },
    { title: "К оплате", render: renderDebet, align: "right", width: "15%" },
    Table.EXPAND_COLUMN,
  ]

  const onRowClick = (record) => {
    const key = record.key;
    setSelected(prevKeys => prevKeys.includes(key) ? prevKeys.filter(k => k !== key) : [key]);
  }

  const onItemClose = (refresh) => {
    setSelected([]);
    refresh && getData();
    refresh && onRefresh(true);
  }

  const items2 = [...sales.map(i => ({...i, key: `s${i.id}`, vid: 1})), ...uses.map(i => ({...i, key: `u${i.id}`, vid: 2}))]

  const onChange = value => setItemZag({...itemZag, ...value});

  const onFormValuesChange = () => {
    setFormModified(true);
  }

  const onSave = () => {
    setLoading(true);
    const saveData = isMobile ? {...itemZag, ...form.getFieldsValue()} : itemZag;
    serverFetch("visit", { method: "PUT", bodyData: saveData })
      .then(() => {
        setLoading(false);
        const updatedItemZag = {...saveData, modified: false};
        setItemZag(updatedItemZag);
        setFormModified(false);
        if (isMobile) {
          form.setFieldsValue({ comment: saveData.comment || '', keyName: saveData.keyName || '' });
        }
        onRefresh(true);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onCloseSaleAdd = () => {
    setSaleAdd(false);
    getData();
    onRefresh();
  }

  const addProductByBarcode = value => {
    let barcode = value;
    if (barcode.length > 15 && barcode.startsWith("01"))
      barcode = barcode.slice(3, 16);
    serverFetch(`product/GetByBarcode?barcode=${barcode}`)
      .then(data => {
        if (data) {
          const saleItem = {
            qty: 1,
            clientId: itemZag.clientId,
            visitId: itemZag.id,
            productId: data.id,
            price: data.expPrice,
            deleted: false,
            status: 0,
            syma: data.expPrice,
          };
          serverFetch("sale", { method: "POST", bodyData: saleItem })
            .then(() => {
              setLoading(false);
              getData();
              onRefresh();
            })
            .catch(e => {
              setLoading(false);
              message.error(e.userMessage);
            });
        }
        else {
          setLoading(false);
          message.error("Товар не найден!");
        }
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const onScan = value => {
    const code = value?.trim();
    if (!code || item.finish) return;

    setLoading(true);
    serverFetch("Card/assignToVisit", { method: "POST", bodyData: { code, visitId: item.id } })
      .then(result => {
        if (result?.assigned || result?.Assigned) {
          setLoading(false);
          onRefresh(true);
          return;
        }
        if (result?.error || result?.Error) {
          setLoading(false);
          message.error(result.error ?? result.Error);
          return;
        }
        addProductByBarcode(code);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };
  
  const divVisitInfo = isMobile ? 
    <>
      <div style={{marginBottom:"8px"}}>
        <Card className="visit-item-card" onClick={() => setVisitInfoExpanded(!visitInfoExpanded)}
          style={{ padding: '4px', cursor: "pointer", borderLeft: `4px solid ${item?.finish != null ? "#808080" : "#d9d9d9"}`}}>
          <div className="visit-item-debt">
            <Text strong className="visit-item-clip">
              Визит #{itemZag?.id}
            </Text>
            {penaltyLabel}
            {itemZag?.productName && (
              <Text className="visit-item-clip-right">Абонемент: {itemZag.productName}</Text>
            )}
          </div>

          <div className="visit-item-info-fields">
            <Text className="visit-item-clip">Комм.: {itemZag?.comment || '-'}</Text>
            <Text className="visit-item-clip-right">
              Ключ: {itemZag?.keyName || '-'}
            </Text>
          </div>
          <div className="visit-item-info-fields">
            <Text className="visit-item-clip">Доп. карта: {itemZag?.cardCode || '-'}</Text>
          </div>

          <div className="visit-item-card-fields">
            <Text style={{fontSize: "13px"}} strong className="visit-item-clip">Начало: {fmtDate(item?.start)} в {fmtTimeHM(item?.start) || '-'}</Text>
            <Text style={{fontSize: "13px"}} strong className="visit-item-clip-right">
              Окончание: {fmtTimeHM(item?.finish) || '-'}
            </Text>
          </div>

          <div
            className="visit-item-expand"
            style={{ maxHeight: visitInfoExpanded ? 800 : 0,
              opacity: visitInfoExpanded ? 1 : 0,
              overflow: "hidden",
            }}
          >
            {visitInfoExpanded && (
              <div onClick={e => e.stopPropagation()} style={{ marginTop: '8px' }}>
                <Form form={form} colon={false}  labelCol={{ flex: "50px" }} wrapperCol={{ flex: "1" }} onValuesChange={onFormValuesChange}
                  className="client-subitem-sales-content" style={{ paddingTop: "8px" }}>
                  <Form.Item label="Комм." name="comment">
                    <Input placeholder="Введите комментарий" />
                  </Form.Item>
                  <Form.Item label="Ключ" name="keyName">
                    <Input placeholder="Введите номер ключа" disabled={!!itemZag.cardCode} />
                  </Form.Item>
                  <Form.Item label="Доп. карта">
                    <Input value={itemZag?.cardCode || ''} disabled placeholder="Считайте доп. карту" />
                  </Form.Item>
                  <Button disabled={!formModified} onClick={(e) => { e.stopPropagation(); onSave();}} type="primary" block loading={loading}>
                    Сохранить
                  </Button>
                </Form>
              </div>
            )}
          </div>
        </Card>
        {divAccounts}
      </div>
    </> : <>
      <div className="visit-cnt-line">
        <div className="visit-cnt-cell"><b>Визит # {item.id}</b></div>
        {penaltyLabel}
        {item.productName && <><div className="visit-cnt-cell">по абонементу</div><div className="visit-cnt-cell">{item.productName}</div></>}
      </div>

      <div className="visit-cnt-title">
        <div className="visit-cnt-cell">Комментарий</div>
        <div className="visit-cnt-cell">
          <Input value={itemZag.comment} onChange={e => onChange({ comment: e.target.value, modified: true })} />
        </div>
        <div className="visit-cnt-cell">Ключ</div>
        <div className="visit-cnt-cell">
          <Input value={itemZag.keyName} onChange={e => onChange({ keyName: e.target.value, modified: true })} disabled={!!itemZag.cardCode} />
        </div>
        <div className="visit-cnt-cell">Доп. карта</div>
        <div className="visit-cnt-cell">
          <Input value={itemZag.cardCode || ''} disabled placeholder="Считайте доп. карту" />
        </div>
        <Button disabled={!itemZag.modified} onClick={onSave}>Сохранить</Button>
      </div>
      {divAccounts}
    </>

  const divVisitBody = isMobile ?
    <> 
      <div className="visit-mobile-container">
        <div className="visit-mobile-content">
          {page === 0 && <>
           {sales.map (item => {
            const isExpanded = editId == item.id;
            /* console.log(item) */
            return ( //VisitItemSaleMobile
              <div key={item.id}>
                <div onClick={() => setEditId(isExpanded ? null : item.id)} style={{ cursor: "pointer", marginBottom: 4 }}>
                <Card
                    className="visit-item-card"
                    onClick={() => setEditId(isExpanded ? null : item.id)}
                    style={{ padding: '4px', cursor: "pointer", borderLeft: `4px solid ${isExpanded ? "#2f6f00" : "#d9d9d9"}`}}
                  >
                    <div className="visit-item-card-name-debt">
                      <Text strong className="visit-item-clip">
                        {item.productName}
                      </Text>
                      <Text
                        strong
                        className="visit-item-clip-right"
                        style={{ color: item.debet > 0 ? "#ff4d4f" : undefined }}
                      >
                        К оплате: {item.debet}
                      </Text>
                    </div>

                    {/* Price / qty / discount / sum */}
                    <div className="visit-item-card-fields">
                      <Text className="visit-item-clip">Цена: {item.price}</Text>
                      <Text className="visit-item-clip">Кол-во: {item.qty}</Text>
                      <Text className="visit-item-clip">Скидка %: {item.discountPrc}</Text>
                      <Text className="visit-item-clip">Сумма: {item.syma}</Text>
                    </div>

                    {/* Expandable content */}
                    <div
                      className="visit-item-expand"
                      style={{
                        maxHeight: isExpanded ? 800 : 0,
                        opacity: isExpanded ? 1 : 0,
                        transition: "all 0.3s ease",
                        overflow: "hidden",
                      }}
                    >
                      {isExpanded && (
                        <div onClick={e => e.stopPropagation()}>
                          <VisitCntItem onClose={onItemClose} itemDefault={item}/>
                        </div>
                      )}
                    </div>
                  </Card>
                </div>
              </div>
            )
          })}
            <Button onClick={() => setSaleAdd(true)} disabled={loading || item.finish} style={{marginTop:"6px", width: "100%"}}>Продать</Button>
          </>}
          {page === 1 && <ClientAbons id={item.clientId} finish={item.finish}/>}
          {page === 2 && item.clientId && <VisitCntPacket clientId={item.clientId} onRefresh={() => { onRefresh(); getData(); }} visitId={item.id} />}
        </div>

      </div>
      {saleAdd && <SaleAdd visitId={item.id} clientId={item.clientId} onClose={onCloseSaleAdd} activeBtns={page === 0 ? ["Товар", "Услуга", "Сертификат"] : ["Абонемент", "Пакет"]} />}
    </> : <>
      <div className="visit-cnt-menu">
        <div className={`visit-cnt-menu-item ${page === 0 ? " visit-cnt-menu-item-select" : ""}`} onClick={() => setPage && setPage(0)}>Продажи</div>
        {item.clientId && !item.finish && <div className={`visit-cnt-menu-item ${page === 1 ? " visit-cnt-menu-item-select" : ""}`} onClick={() => setPage && setPage(1)}>Пакеты</div> }
        {item.clientId && !item.finish && <div className={`visit-cnt-menu-item ${page === 2 ? " visit-cnt-menu-item-select" : ""}`} onClick={() => setPage && setPage(2)}>Абонементы</div> }
      </div>
      {page === 0 && <div className="visit-cnt-tools">
        <Space style={{marginBottom: 4}}>
          <Button onClick={() => setSaleAdd(true)} disabled={loading || item.finish}>Продать</Button>
          <ButtonReport vid={3} id={item.id} />
          <ScanButton title="Просканируйте штрихкод или QR код товара" onScan={onScan}/>      
        </Space>
        <Table 
        columns={columns} size="small" dataSource={items2} loading={loading} pagination={false} rowKey="key" 
        expandable={{
          expandedRowRender: (record) => record.vid === 1 ? 
            <VisitCntItem onClose={onItemClose} itemDefault={record} /> : 
            <VisitCntPacketItem onClose={onItemClose} itemDefault={record} />, expandedRowKeys: selected,
          onExpand: (expanded, record) => setSelected(expanded ? [record.key] : []),
          expandIcon: ({ expanded, onExpand, record }) => expanded ? <DownOutlined onClick={(e) => onExpand(record, e)} /> : <RightOutlined onClick={(e) => onExpand(record, e)} />,
          rowExpandable: () => true,
          className: "cl-abons-expandable",
        }}
        onRow={record => ({ onClick: () => onRowClick(record) })}
        rowSelection={{ type: 'radio', selectedRowKeys: selected, renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
      />
      {saleAdd && <SaleAdd visitId={item.id} clientId={item.clientId} onClose={onCloseSaleAdd} activeBtns={["Товар", "Услуга", "Сертификат"]} />}
      </div>}
      {page === 1 && item.clientId && <VisitCntPacket clientId={item.clientId} onRefresh={() => {onRefresh(); getData();}} visitId={item.id}/>}
      {page === 2 && item.clientId && <ClientAbons id={item.clientId} finish={item.finish}/>}
    </>

  return<div className="visit-section ">
    {divVisitInfo}
    {divVisitBody}
    <Scan onScan={onScan}/>
  </div>
}

export default VisitCnt;
